var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{attrs:{"points":_vm.getSvgPolygon(),"fill":("url(#pattern-section" + _vm.idSection + "_" + _vm.indexThisPolygon + ")"),"data-section":_vm.idSection}})}
var staticRenderFns = []

export { render, staticRenderFns }